import React, { PureComponent } from "react";
import ReactDOM, { findDOMNode } from "react-dom";

import Template from "./Overlay.jsx";
import "./styles.styl";

export default class OverlayController extends PureComponent {
  constructor(props) {
    super(props);

    this.handlers = {
      onClick: this.onClick.bind(this),
    };
  }

  componentDidMount() {
    this.el = findDOMNode(this);
    this.innerEl = this.el.querySelector(".overlay__inner");
  }

  onClick(e) {
    const { target } = e;
    const { onClick, onClose } = this.props;

    console.log("overlay-click");

    onClick && onClick(e);

    if (target === this.innerEl || this.innerEl.contains(target)) return;

    onClose && onClose();
  }

  render() {
    return ReactDOM.createPortal(
      <Template {...this.props} {...this.state} {...this.handlers} />,
      document.body,
    );
  }
}
